import { Inject, Injectable, Injector } from "@angular/core";
import { BaseApi } from "../base-api";
import { APP_CONFIGURATION } from "../../../../../core/src/lib/core.di";
import { AppConfig } from "../../../../../core/src/lib/app-config/config.types";
import { MapGeocoder } from "@angular/google-maps";
import { catchError, from, map, Observable, of } from "rxjs";

@Injectable({ providedIn: "root" })
export class GoogleGeocodingApi extends BaseApi {
  constructor(
    private readonly injector: Injector,
    @Inject(APP_CONFIGURATION) readonly appConfig: AppConfig,
    private readonly geocoder: MapGeocoder,
  ) {
    super(injector);
  }

  decodeAddress(address: string, language = 'de'): Observable<Array<google.maps.GeocoderResult>> {
    //return this.geocoder.geocode({ address, language, region: 'de' }).pipe(
    if(!this.appConfig.production) console.info(JSON.stringify({address, language}));
    return this.geocoder.geocode({ address, language, region: 'de,ch,at,en' }).pipe(
      map((response) => {
        if (response.status === "OK") {
          console.log(response);
          return response.results;
        }
        console.log(response);
        return [];
      }),
    );
  }

  searchCities(input: string, countryCode?: string): Observable<Array<google.maps.places.AutocompletePrediction>> {
    if (!input || input.trim().length < 2 || typeof google === "undefined" || !google.maps?.places) return of([]);

    const service = new google.maps.places.AutocompleteService();
    return from(service.getPlacePredictions({
      input,
      types: ["(cities)"],
      componentRestrictions: countryCode ? { country: countryCode } : undefined,
    })).pipe(
      map((response) => response.predictions || []),
      catchError(() => of([])),
    );
  }
}
